import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SplashScreen from '../pwa/SplashScreen';
import InvestorLoginScreen from './InvestorLoginScreen';

type FlowStage = 'splash' | 'login';

const InvestorPWAEntryFlow: React.FC = () => {
  const [stage, setStage] = useState<FlowStage>('splash');
  const navigate = useNavigate();

  useEffect(() => {
    const isLoggedIn = !!localStorage.getItem('investorName') && !!localStorage.getItem('investorId');
    if (isLoggedIn) {
      navigate('/investor-pwa/dashboard', { replace: true });
      return;
    }

    if (stage === 'splash') {
      const timer = setTimeout(() => {
        setStage('login');
      }, 1200);

      return () => clearTimeout(timer);
    }
  }, [stage, navigate]);

  if (stage === 'splash') {
    return <SplashScreen />;
  }

  return <InvestorLoginScreen onSuccess={() => navigate('/investor-pwa/dashboard')} />;
};

export default InvestorPWAEntryFlow;
